/**
 * Who hears a zone line (ADR 0033, amended 2026-10-16). The open world is one
 * room (ADR 0010), so « the zone » is the region the speaker stands in; a
 * zone without biomes (tutorial, dungeons) is heard whole.
 */
export function hearsZoneChat(spoken, heard) {
    return spoken === undefined || spoken === heard;
}
//# sourceMappingURL=chat-reach.js.map